import moment from 'moment'

export const isBeforeDay = (a, b) => {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false

  const aYear = a.year()
  const aMonth = a.month()

  const bYear = b.year()
  const bMonth = b.month()

  const isSameYear = aYear === bYear
  const isSameMonth = aMonth === bMonth

  if (isSameYear && isSameMonth) return a.date() < b.date()
  if (isSameYear) return aMonth < bMonth
  return aYear < bYear
}

export const isInclusivelyAfterDay = (a, b) => {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false
  return !isBeforeDay(a, b)
}

export const getMonths = () => {
  const months = []
  const dateStart = moment()
  const dateEnd = moment().add(12, 'month')

  while (dateEnd.diff(dateStart, 'months') >= 0) {
    months.push(dateStart.format('MMMM YYYY'))
    dateStart.add(1, 'month')
  }

  return months
}

export const daysUntilEndOfMonth = startDate => {
  const days = []
  const endMonth = startDate.clone().endOf('month')
  const today = moment()

  const startDatePrev = startDate.clone().format('YYYY-MM-DD')

  if (moment(startDatePrev).isSame(today.clone().format('YYYY-MM-DD'), 'month')) {
    while (endMonth.diff(today) >= 0) {
      days.push(today.format('DD'))
      today.add(1, 'day')
    }

    return days
  }

  while (endMonth.diff(startDate) >= 0) {
    days.push(startDate.format('DD'))
    startDate.add(1, 'day')
  }

  return days
}

export const hasLegalAge = date => {
  if (!moment(date, 'DD/MM/YYYY').isValid()) {
    return null
  }

  const formatedDate = moment(date, 'DD/MM/YYYY')
  const years = moment().diff(formatedDate, 'years')
  return years >= 18
}

export const formatUTCToLocalDate = date => {
  return moment
    .utc(date, false)
    .local()
    .format('DD/MM/YYYY - HH:mm')
}
